import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useLang } from "@/context/AppContext";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

export const Waitlist = () => {
  const { t, lang } = useLang();
  const [f, setF] = useState({ name: "", email: "", kind: "person", sector: "", use_case: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/waitlist", { ...f, lang });
      toast.success(data.already ? t("wl_already") : t("wl_ok"));
      setDone(true);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section id="waitlist" className="border-t border-white/5 bg-[#0d121c] py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl gap-16 px-4 sm:px-6 lg:grid-cols-12 lg:px-12">
        <div className="lg:col-span-5">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-emerald-400/90">{t("wl_kicker")}</p>
          <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-white lg:text-4xl">{t("wl_title")}</h2>
          <p className="mt-6 text-base leading-relaxed text-slate-400">{t("wl_sub")}</p>
        </div>
        <form onSubmit={submit} className="space-y-5 rounded-md border border-white/[0.08] bg-[#111827] p-8 lg:col-span-7" data-testid="waitlist-form">
          {done && <p className="rounded-md border border-emerald-400/30 bg-emerald-400/10 p-3 text-sm text-emerald-300" data-testid="waitlist-success">{t("wl_ok")}</p>}
          <div className="grid gap-5 sm:grid-cols-2">
            <Input required placeholder={t("wl_name")} value={f.name} onChange={set("name")} data-testid="waitlist-name-input" />
            <Input required type="email" placeholder={t("wl_email")} value={f.email} onChange={set("email")} data-testid="waitlist-email-input" />
          </div>
          <div className="flex items-center gap-3">
            <span className="text-sm text-slate-400">{t("wl_kind")}</span>
            {["person", "company"].map((k) => (
              <button type="button" key={k} onClick={() => setF({ ...f, kind: k })} data-testid={`waitlist-kind-${k}`}
                className={`rounded-full border px-4 py-1.5 text-sm transition-colors duration-200 ${f.kind === k ? "border-emerald-400 bg-emerald-400/10 text-emerald-300" : "border-white/10 text-slate-400 hover:text-white"}`}>
                {t(k === "person" ? "wl_person" : "wl_company")}
              </button>
            ))}
          </div>
          <Input placeholder={t("wl_sector")} value={f.sector} onChange={set("sector")} data-testid="waitlist-sector-input" />
          <Textarea placeholder={t("wl_use")} value={f.use_case} onChange={set("use_case")} rows={3} data-testid="waitlist-usecase-input" />
          <button disabled={busy} data-testid="waitlist-submit-btn" className="w-full rounded-full bg-emerald-500 py-3 text-sm font-semibold text-slate-950 transition-opacity duration-200 hover:opacity-90 disabled:opacity-50">
            {busy ? "…" : t("wl_submit")}
          </button>
        </form>
      </div>
    </section>
  );
};
